import { useEffect, useMemo, useState } from "react";
import { useStations } from "./api";

export function useTitle(title?: string) {
  useEffect(() => {
    document.title = title
      ? `${title} · Poplista`
      : "Poplista – archiwum radiowych list przebojów";
  }, [title]);
}

export function useDebounced<T>(value: T, ms = 250): T {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setV(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return v;
}

/** chart slug -> station slug, for picking a logo when all we have is a chart. */
export function useStationOfChart(): (chart: string) => string | undefined {
  const { data } = useStations();
  const map = useMemo(() => new Map(data?.stations.flatMap((s) => s.charts.map((c) => [c.slug, s.slug] as const))), [data]);
  return (chart) => map.get(chart);
}
